const translations = {
    save: 'Save',
    uploadFlights: 'Upload Flights'
};

export default translations;
